/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { DARK_GREY, RED_CREEK, WHITE } from "../../../styles/colors";

const dayButtonCss = (active: boolean) => css`
  width: 30px;
  height: 30px;
  border-radius: 2px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  font-size: 14px;
  font-weight: 600;

  cursor: pointer;
  user-select: none;

  background-color: ${active ? RED_CREEK : "transparent"};
  color: ${active ? WHITE : DARK_GREY};

  border: none;
  padding: 0;

  /* Remove default button styles */
  appearance: none;

  &:hover {
    filter: brightness(0.95);
  }

  &:focus-visible {
    outline: 2px solid ${RED_CREEK};
    outline-offset: 2px;
  }
`;

type DayOfWeekToggleProps = {
  label: string;
  active: boolean;
  onToggle: () => void;
};

export function DayOfWeekToggle({
  label,
  active,
  onToggle,
}: DayOfWeekToggleProps) {
  return (
    <button
      type="button"
      css={dayButtonCss(active)}
      onClick={onToggle}
      title={label}
    >
      {label}
    </button>
  );
}
